import api from './api';

// Collections — see backend collectionsRoutes.js (administrators only).
const collectionsService = {
  // owedBy: all | patient | scheme → { rows, totals, schemes, follow_ups_due }
  debtors: ({ owedBy = 'patient', q } = {}) => api.get('/collections/debtors', { params: { owed_by: owedBy, q: q || undefined } }).then((r) => r.data),
  account: (patientId) => api.get(`/collections/accounts/${patientId}`).then((r) => r.data.account),
  previewStatement: (patientId) => api.get(`/collections/accounts/${patientId}/statement`).then((r) => r.data),
  // method: email | print → { statement_id, html, emailed, sent_to }
  issueStatement: (patientId, method, email) =>
    api.post(`/collections/accounts/${patientId}/statement`, { method, email: email || undefined }, { timeout: 60000 }).then((r) => r.data),
  followUp: (patientId, body) => api.post(`/collections/accounts/${patientId}/followups`, body).then((r) => r.data.account),
  // { payer: scheme | patient, amount, method?, reference?, received_on?, note? }
  payment: (draftId, body) => api.post(`/collections/invoices/${draftId}/payments`, body).then((r) => r.data.draft),
  writeOff: (draftId, amount, note) => api.post(`/collections/invoices/${draftId}/write-off`, { amount, note }).then((r) => r.data.draft),
  transfer: (draftId, note) => api.post(`/collections/invoices/${draftId}/transfer`, { note: note || undefined }).then((r) => r.data.draft),
};

export default collectionsService;
